<template>
    <div class="w-100">
        <div class="bg-primary-light d-flex justify-content-center align-items-center mb-3" style="min-height: 70px;">
            <div class="row text-capitalize">
                <span style="font-weight: 600; font-size: 18px;">
                    {{ dt(promotion.title_translations) }}
                </span>
            </div>
        </div>
        <div class="mx-auto d-block d-md-none">
            <div class="col-12">
                <div class="bg-white rounded shadow-lg p-3 p-md-4" style="font-size: 22px;font-weight:700;">
                    <!-- 手機版 -->
                    <promotion-title-block :promotion="promotion" :store-data="storeData" :is_login="is_login" @buy-now="clickQuickAddToCart(true)"
                        @add-to-cart="clickQuickAddToCart(false)" @msg="redirectToFBMSN">
                        <template #title>
                            <RatioImage v-if="promotion.banner_media" ratio="1:1"
                                :src="imgProxy(promotion.banner_media?.url)" :tip="dt(promotion.title_translations)" />
                        </template>
                    </promotion-title-block>
                </div>
            </div>
        </div>

        <div class="pb-4 mx-auto">
            <div class="w-100">
                <div class="bg-white rounded shadow-lg p-3 p-md-4 d-none d-md-block"
                    style="font-size: 22px;font-weight:700;">
                    <!-- 桌面版不顯示活動banner -->
                    <promotion-title-block :promotion="promotion" :store-data="storeData" :is_login="is_login" @buy-now="clickQuickAddToCart(true)"
                        @add-to-cart="clickQuickAddToCart(false)" @msg="redirectToFBMSN" />
                </div>

                <div v-if="description_translations" class="bg-white text-dark rounded shadow-lg p-3 p-md-4 mt-4"
                    style="font-size: 22px;font-weight:700;">
                    <div v-html="description_translations"></div>
                </div>
            </div>
        </div>

        <a name="buy-now-block"></a>
        <div class="d-flex justify-content-center align-items-center mb-3"
            style="min-height: 70px;background:#3b71de10;width:100%;">
            <div class="row text-capitalize">
                <span style="font-weight: 600;font-size: 18px;">活動商品</span>
            </div>
        </div>

        <div class="rtl" style="text-align: left;">
            <div class="row mt-3" :class="buyNow ? 'alerts-border rounded' : ''">
                <promotion-product-item 
                    v-for="item in promotion.whitelisted_store_products" 
                    :key="item.id" 
                    :item="item"
                    :is-coming="isComing" 
                    :is-ended="isEnded" 
                    :display-coin-reward="promotion.display_coin_reward"
                    :is_login="is_login" 
                    :is-distribute="isDistribute" 
                    :target="target" 
                    :store-data="storeData"
                    @add="handleAddToCart"
                    @show="handleShowItem" 
                    @show-coin="showCoinLevel" 
                    @view="handleQuickView"
                    @quick-add="handleQuickAddToCart" 
                />
            </div>
        </div>

        <div v-if="promotion.discount_type == 'gift'" class="d-flex justify-content-center align-items-center mb-3"
            style="min-height: 70px;background:#3b71de10;width:100%;">
            <div class="row text-capitalize">
                <span style="font-weight: 600;font-size: 18px;">
                    {{ t("carts.gift") }}
                </span>
            </div>
        </div>

        <div v-if="promotion.discount_type == 'gift'" class="rtl" style="text-align: left;">
            <div class="row mt-3">
                <div v-for="item in promGifts" class="col-lg-3 col-md-4 col-sm-4 col-6 pb-3">
                    <div class="h-100">
                        <div class="inline_product clickable d-flex justify-content-center"
                            style="cursor: pointer;background:#3b71de10; border-radius: 5px 5px 0px 0px;">
                            <div class="d-flex justify-content-end for-dicount-div-null">
                                <span class="for-discoutn-value-null"></span>
                            </div>
                            <div class="d-flex d-block" style="cursor: pointer;" @click="handleQuickView(item, false)">
                                <el-image :src="imgProxy(item.image_url, rs = 'fill:250:250:1')"
                                    :alt="dt(item.name_translations)" style="width: 100%; border-radius:5px 5px 0px 0px;"
                                    >
                                    <template #error>
                                        <img src="/static/assets/front-end/img/image-place-holder.png"
                                            :alt="dt(item.name_translations)" style="width: 100%;">
                                    </template>
                                </el-image>
                            </div>
                        </div>

                        <div class="single-product-details"
                            style="position:relative; padding-top:10px; border-radius:0px 0px 5px 5px; ">
                            <div class="text-left pl-3" @click="handleQuickView(item, false)">
                                {{ dt(item.name_translations) }}
                            </div>
                        </div>

                        <a v-if="promotion.condition_min_type == 'amount'" class="btn btn-primary btn-block mt-2 disabled"
                            role="button" aria-disabled="true" href="#">
                            {{ t("promotions.fill") }}
                            {{ item.condition.min_amount }}, {{ t("promotions.gift")
                            }}{{ item.condition.discountable_quantity }} {{ t("promotions.fillUnit") }}
                        </a>
                        <a v-if="promotion.condition_min_type == 'qty'" class="btn btn-primary btn-block mt-2 disabled"
                            role="button" aria-disabled="true" href="#">
                            {{ t("promotions.fill") }}
                            {{ item.condition.min_qty }} {{ t("promotions.fillUnit") }}, {{ t("promotions.gift")
                            }}{{ item.condition.discountable_quantity }} {{ t("promotions.fillUnit") }}
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <div class="d-md-none fixed-bottom" style="background-color: #eaeaea; height: 74px; border-top: 1px solid #eee;">
            <promotion-title-block :promotion="promotion" :store-data="storeData" :is_login="is_login" button-only
                @buy-now="clickQuickAddToCart(true)" @add-to-cart="clickQuickAddToCart(false)" @msg="redirectToFBMSN" />
        </div>

        <div class="d-flex justify-content-center align-items-center mb-3"
            style="min-height: 70px;background:#3b71de10;width:100%;">
            <div class="row text-capitalize">
                <span style="font-weight: 600;font-size: 18px;">相關活動</span>
            </div>
        </div>
        <div v-if="promotion?.tags && !!promotion.tags.length">
            <template v-for="tag in promotion?.tags" :key="tag">
                <div class="bg-white rounded shadow-lg p-2 text-primary text-center h3">
                    {{ tag }}
                </div>
                <promotion-list :store_prom_group_id="promotion.id" :store-data="storeData" :tags="[tag]" fields="banner_media,price_range"
                    sort="position_asc" hide_header pagination_type="page" :limit="4" />
            </template>
        </div>
        <div v-else>
            <promotion-list :store_prom_group_id="promotion.id" :store-data="storeData" fields="banner_media,price_range" sort="position_asc"
                hide_header pagination_type="infinite" />
        </div>

        <!-- 商品規格選擇 Modal -->
        <el-dialog v-model="modalState.visible" :title="modalState.title" :width="isMobile ? '90%' : '80%'" destroy-on-close
            :append-to-body="true" center>
            <el-form ref="formRef" :model="assorts" scroll-to-error>
                <ul v-if="assorts" class="list-group list-group-flush">
                    <li v-for="(assort, index) in assorts" :key="assort.id" class="list-group-item">
                        <div class="d-flex flex-column flex-md-row w-100 justify-content-md-between align-items-center">
                            <div>
                                <h5 class="mb-1">{{ dt(assort.name_translations) }}</h5>

                                <div>
                                    <span v-if="!hiddenPrice">
                                        <small class="mr-2" style="text-decoration: line-through">
                                            {{ aliasTranslations?.comm_price || '活原價動價' }}
                                            
                                            {{ assort.symbol }}
                                            {{ currencyFormat(assort.comm_price) }}
                                        </small>
                                        <span class="text-primary">
                                            {{ aliasTranslations?.sale_price || '活動價' }}
                                            
                                            {{ assort.symbol }}
                                            {{ currencyFormat(assort.discounted_price) }}
                                        </span>
                                        <small v-if="assort.comm_price - assort.discounted_price > 0">
                                            (揪團省
                                            {{ assort.symbol }}
                                            {{ currencyFormat(assort.comm_price - assort.discounted_price) }})
                                        </small>
                                    </span>

                                    <span v-if="promotion.display_coin_reward && assort.owner_coin_reward > 0"
                                        class="h4 text-warning d-inline-flex">
                                        <img src="/static/images/coin.png" style="max-height: 30px" alt="owner_coin_reward">
                                        {{ currencyFormat(assort.owner_coin_reward) }}
                                    </span>
                                </div>
                            </div>
                            <div v-if="assort.buy_qty && !hiddenPrice" class="mx-3" style="color: #3b71de;">
                                {{ assort.symbol }} {{ currencyFormat(assort.discounted_price * assort.buy_qty) }}
                            </div>
                            <div style="width: 160px">
                                <el-form-item :prop="index + '.buy_qty'" :rules="[
                                    {
                                        type: 'number',
                                        min: !!assort.buy_qty ? assort.min_order_quantity : 0,
                                        max: assort.max_order_quantity || assort.inventory,
                                        message: `請輸入 ${assort.min_order_quantity} ~ ${assort.max_order_quantity || assort.inventory} 之間`, trigger: 'blur'
                                    },
                                ]">
                                    <span v-if="!assort.unlimited_inventory && assort.inventory <= 0"
                                        class="text-primary h4">已售完</span>
                                    <product-quantity v-else v-model="assorts[index].buy_qty"
                                        :min="assort.min_order_quantity"
                                        :max="assort.max_order_quantity || assort.inventory" :disabled="loadingForm" />
                                    <template #error="{ error }">
                                        <div class="w-100 text-danger text-center">{{ error }}</div>
                                    </template>
                                </el-form-item>
                            </div>
                        </div>
                    </li>
                </ul>
            </el-form>
            <template #footer>
                <div v-if="cartTotal" class="px-3 mb-3 alert alert-secondary">
                    <div v-if="!hiddenPrice" class="row">
                        <div v-if="assortDiscountTotal > 0" class="d-inline pr-3">
                            商品折扣：<span class="text-primary">-{{ assortSymbol }} {{ currencyFormat(assortDiscountTotal)
                            }}</span>
                        </div>
                        <div v-if="promDiscountTotal > 0" class="d-inline pr-3">
                            活動折扣：<span class="text-primary">-{{ assortSymbol }} {{ currencyFormat(promDiscountTotal)
                            }}</span>
                        </div>
                    </div>

                    <div class="row">
                        <div v-if="!hiddenPrice" class="d-inline pr-3">
                            {{ t('carts.subTotal') }}:
                            <span class="text-primary">{{ assortSymbol }} {{ currencyFormat(cartTotal) }}</span>
                        </div>
                        <div class="d-inline pr-3">
                            總件數：<span class="text-primary">{{ currencyFormat(cartCount) }}</span>
                        </div>
                    </div>
                </div>

                <!-- <button class="btn btn-outline-dark mr-2" type="button" :disabled="loadingForm" @click="handleCloseItem">
                    {{ t("global.cancel") }}
                </button> -->

                <button v-if="!hiddenCart" class="btn btn-secondary" type="button" :disabled="loadingForm || !cartCount"
                    @click="addToCart(false)">
                    {{ aliasTranslations?.add_to_cart || t("carts.addToCart") }}
                </button>

                <button v-if="!hiddenCart" class="btn btn-primary ml-2" type="button" :disabled="loadingForm || !cartCount"
                    @click="addToCart(true)">
                    {{ aliasTranslations?.buy_now || t("carts.buyNow") }}
                </button>

            </template>
        </el-dialog>

        <promotion-product-quick-view v-if="dialogVisible" v-model="dialogVisible" :product="modalState.item"
            :is-distribute="isDistribute" :target="target" :assort-detail="assortDetail" @show="handleShowItem"
            @add="handleAddToCart" />
        <promotion-coin-detail v-if="levelState.visible" v-model="levelState.visible" :product="levelState.item"
            :levels="distributorLevels" :distributor="distributor" />
        <promotion-product-quick-add v-model="prodState.visible" :data="promotion?.whitelisted_store_products"
            @ok="handleQuickAddToCart" />
        <!-- <pre>{{ promotion?.tags }}</pre> -->
    </div>
</template>

<script setup>
import { reactive, ref, computed, onMounted } from 'vue'
import { useI18n } from "vue-i18n"
import { _api_createCartGroup, _api_getProduct } from "../api/index.js";
import { breakpoint, parseVideoTag, redirectFBMSN, lookupAliasTranslations } from "../utils"
import { dataTranslations as dt, notificationErrors, currencyFormat, checkValidCurrencyStr, dateFormat, assignCartCount, imgProxy } from "../utils"
import PromotionTitleBlock from "./promotions/PromotionTitleBlock.vue"
import PromotionList from "./promotions/PromotionList.vue"
import PromotionProductItem from "./promotions/PromotionProductItem2.vue"
import ProductQuantity from "./products/ProductQuantity.vue"
import PromotionProductQuickView from "./promotions/PromotionProductQuickView.vue"
import PromotionProductQuickAdd from "./promotions/PromotionProductQuickAdd.vue"
import PromotionCoinDetail from "./promotions/PromotionCoinDetail.vue"
import RatioImage from './RatioImage.vue'
import { ElLoading } from 'element-plus'

const props = defineProps({
    promotion: Object,
    distributor: Object,
    distributorLevels: Array,
    payments: Object,
    logistics: Object,
    trackers: Object,
    fbmsn_base_url: String,
    store_id: Number,
    ref_store_id: Number | null,
    page_id: String,
    is_login: { type: Boolean, default: false },
    storeData: { type: Object, required: true },
})
// const emit = defineEmits(['create-event'])

const { t, n, locale } = useI18n()

const hiddenPrice = computed(() => !!props.storeData?.settings?.hidden_price)
const hiddenCart = computed(() => !!props.storeData?.settings?.hidden_cart)
const hiddenContact = computed(() => !!props.storeData?.settings?.hidden_contact)
const aliasTranslations = computed(() => lookupAliasTranslations(props.storeData?.alias_translations, locale.value))

const isMobile = computed(() => breakpoint.value.xs)
const isDistribute = computed(() => !!props.distributor?.id)
const target = computed(() => props.promotion.target)
const assortSymbol = computed(() => assorts.value.length ? assorts.value[0].symbol : "")
const assortOrgTotal = computed(() => assorts.value.reduce((total, assort) => (total += assort.comm_price * assort.buy_qty), 0))
const assortTotal = computed(() => assorts.value.reduce((total, assort) => (total += assort.discounted_price * assort.buy_qty), 0))
const assortDiscountTotal = computed(() => assortOrgTotal.value - assortTotal.value)
const cartCount = computed(() => assorts.value.reduce((total, assort) => (total += assort.buy_qty), 0))
const cartTotal = computed(() => assortTotal.value - promDiscountTotal.value)
const promDiscountTotal = computed(() => {
    let discount_type = props.promotion.discount_type;
    let discount_value = null;

    // 滿額
    if (props.promotion?.condition_min_type == 'amount') {
        props.promotion.conditions.forEach((condition) => {
            if (assortTotal.value >= condition.min_amount) {
                if (discount_type == 'amount') {
                    discount_value = condition.discount_amount
                } else if (discount_type == 'percentage') {
                    discount_value = condition.discount_percentage
                }
            }
        })
    }
    // 滿件
    else if (props.promotion?.condition_min_type == 'qty') {
        props.promotion.conditions.forEach((condition) => {
            if (cartCount.value >= condition.min_qty) {
                if (discount_type == 'amount') {
                    discount_value = condition.discount_amount
                } else if (discount_type == 'percentage') {
                    discount_value = condition.discount_percentage
                }
            }
        })
    }

    if (discount_type && discount_value) {
        if (discount_type == 'amount') {
            return discount_value
        } else if (discount_type == 'percentage') {
            return assortTotal.value * (discount_value / 100)
        }
    }
    return 0
})
const promDiscountableStoreProductMap = computed(() => _.keyBy(props.promotion.discountable_store_products, "id"));

const description_translations = computed(() => {
    if (Object.keys(props.promotion.description_translations).length) {
        let desc = dt(props.promotion.description_translations)
        // console.log("desc: ", desc)
        return parseVideoTag(desc)
    }
    return null
})
const term_translations = computed(() => {
    if (Object.keys(props.promotion.term_translations).length) {
        let term = dt(props.promotion.term_translations)
        return term
    }
    return null
})

const whitelistedPaymentNames = computed(() => {
    let whitelisted_payment_names = []
    props.payments.forEach((payment) => {
        // if (props.promotion.whitelisted_payment_types.includes(payment.type)) {
            whitelisted_payment_names.push(dt(payment.name_translations))
        // }
    })
    return whitelisted_payment_names
})
const whitelistedLogisticNames = computed(() => {
    let whitelisted_logistic_names = []
    props.logistics.forEach((logistic) => {
        // if (props.promotion.whitelisted_delivery_types.includes(logistic.delivery_type)) {
            whitelisted_logistic_names.push(dt(logistic.name_translations))
        // }
    })
    return whitelisted_logistic_names
})

const isComing = computed(() => props.promotion.start_at ? dayjs(props.promotion.start_at) > dayjs() : false)
const isEnded = computed(() => props.promotion.ended_at ? dayjs(props.promotion.ended_at) < dayjs() : false)

const promGifts = computed(() => {
    let tmpGifts = []
    if (props.promotion.discount_type == 'gift') {
        props.promotion.conditions.forEach((condition) => {
            condition.discountable_store_product_ids.forEach((store_product_id) => {
                const gift = _.cloneDeep(promDiscountableStoreProductMap.value[store_product_id.toString()])
                if (gift) {
                    gift.condition = condition
                    tmpGifts.push(gift)
                }
            })
        })
    }
    return tmpGifts
})

const formRef = ref()
const buyNow = ref(false)
const loadingForm = ref(false)
const assorts = ref([])
const modalState = reactive({
    title: "",
    item: null,
    visible: false,
})
const dialogVisible = ref(false)
const format = "YYYY/MM/DD HH:mm a"

const getAssorts = () => {
    let tmpAssorts = [];
    // console.log("getAssorts: ", this.promotion);
    modalState.item.assorts.forEach((assort) => {
        let data = {
            ...assort,
            store_assort_id: assort.id,
            store_assort_name: dt(assort.name_translations),
            store_product_id: modalState.item.id,
            store_product_name: dt(modalState.item.name_translations),
            buy_qty: 0,
        };
        tmpAssorts.push(data)
    })
    assorts.value = tmpAssorts
}

const handleShowItem = (item) => {
    // console.log("handleShowItem: ", item);
    modalState.title = dt(item.name_translations);
    modalState.item = item;
    getAssorts();
    modalState.visible = true
}

const assortDetail = ref(true)
const handleQuickView = (item, select_assort_btn = true) => {
    // console.log("handleQuickView: ", item);
    assortDetail.value = select_assort_btn
    modalState.title = dt(item.name_translations);
    modalState.item = item;
    dialogVisible.value = true
}

const handleCloseItem = () => {
    modalState.visible = false
}

const redirectToFBMSN = (store_product_id = null) => {
    if (!props.fbmsn_base_url) {
        swal.fire({
            title: '查無可用粉絲團資訊',
            type: 'error',
        })
    }
    return redirectFBMSN(
        props.fbmsn_base_url,
        "/promotion",
        props.store_id,
        props.ref_store_id,
        props.promotion.id,
        store_product_id
    )
}

const prodState = reactive({
    visible: false,
    redirect: false,
})
const clickQuickAddToCart = (redirect = false) => {
    if (!props.promotion?.whitelisted_store_products || !props.promotion?.whitelisted_store_products.length) {
        // console.debug("promotion", props.promotion)
        return handleBuyNow()
    }
    prodState.redirect = redirect
    if (props.promotion?.whitelisted_store_products.length === 1) {
        handleQuickAddToCart(props.promotion?.whitelisted_store_products[0])
    } else {
        prodState.visible = true
    }
}

const handleQuickAddToCart = async (item) => {
    window.ElFullPageLoading = ElLoading.service({
        lock: true,
        background: 'rgba(0, 0, 0, 0.5)',
    });
    try {
        if (!item?.assorts || !item?.assorts.length) {
            swal.fire({
                title: '查無商品可用規格',
                type: 'error',
            })
            window.ElFullPageLoading && window.ElFullPageLoading.close();
            return;
        }

        const assort = item.assorts.filter((assort) => assort.inventory > 0)?.[0];

        if (!assort) {
            swal.fire({
                title: '庫存不足',
                type: 'error',
            });
            window.ElFullPageLoading && window.ElFullPageLoading.close();
            return;
        }

        // window.fullPageLoading("show")
        loadingForm.value = true

        const payload = {
            event_id: props.promotion.id,
            event_name: dt(props.promotion.title_translations),
            event_type: props.promotion.type,
            items: [{
                store_product_id: item?.id,
                store_assort_id: assort?.id,
                quantity: 1,
                prod_name: dt(item?.name_translations),
                prod_assort_name: dt(assort?.name_translations),
                price: assort?.discounted_price || assort?.sale_price,
            }],
        };
        // console.log("handleQuickAddToCart", payload);

        addToCartByPayload(payload, prodState.redirect)

    } catch (error) {
        // console.error("handleQuickAddToCart fais", error)
        window.ElFullPageLoading && window.ElFullPageLoading.close();
        notificationErrors(error)
    } finally {
        // window.fullPageLoading("hide")
        loadingForm.value = false
    }
}

const handleAddToCart = (assorts) => {
    redirectToFBMSN(assorts[0].store_product_id)
}

const addToCartByPayload = (payload, redirect = false) => {
    let is_success = false
    _api_createCartGroup(payload)
        .then((data) => {
            // console.log("addToCart success: ", data);
            localStorage.removeItem('ADD_TO_CART_GROUP')
            handleCloseItem()
            assignCartCount(true)
            addToCartSuccess()
            const eventID = data?.headers?.["x-request-id"] ? data?.headers?.["x-request-id"] : null
            aibTrackers.addToCart(payload, null, eventID)
            gtmTrackers.addToCart(payload, null, eventID)
            fbqTrackers.addToCart(payload, null, eventID)
            ttqTrackers.addToCart(payload, null, eventID)
            gtagTrackers.addToCart(payload, null, eventID)
            is_success = true
        })
        .catch((err) => {
            if (err?.errors) {
                const { type, msg } = err.errors[0]
                if (type == "RequireLoginError") {
                    const temp = { "payload": payload, "redirect": redirect }
                    localStorage.setItem('ADD_TO_CART_GROUP', JSON.stringify(temp))
                } else {
                    localStorage.removeItem('ADD_TO_CART_GROUP')
                }
            }
            notificationErrors(err)
        })
        .finally(() => {
            window.fullPageLoading("hide")
            loadingForm.value = false

            if (is_success) {
                if (redirect) {
                    return redirectFBMSN(
                        props.fbmsn_base_url,
                        "/buy_now",
                        props.store_id,
                        props.ref_store_id,
                        props.promotion.id,
                    )
                } else {
                    $("#shopping-cart-drawer").click();
                }
            }
        })
}

const addToCart = (redirect = false) => {
    let items = [];
    assorts.value.forEach((assort) => {
        if (assort.buy_qty) {
            // console.debug("addToCart: ", assort);

            items.push({
                store_product_id: assort.store_product_id,
                store_assort_id: assort.store_assort_id,
                quantity: assort.buy_qty,
                prod_name: assort?.store_product_name,
                prod_assort_name: dt(assort?.name_translations),
                price: assort?.discounted_price || assort?.sale_price,
            })
        }
    });
    if (!items.length) {
        swal.fire({
            title: '請選擇數量',
            type: 'error',
        })
        return
    }
    if (!formRef.value) return

    formRef.value.validate((valid) => {
        if (valid) {

            loadingForm.value = true
            window.fullPageLoading("show")
            let payload = {
                event_id: props.promotion.id,
                event_name: dt(props.promotion.title_translations),
                event_type: props.promotion.type,
                items: items,
            };
            // console.debug("addToCart: ", payload);

            addToCartByPayload(payload, redirect)
        }
    })
}

const addToCartSuccess = () => {
    toastr.success("成功加入購物車", {
        closeButton: true,
        progressBar: true,
        positionClass: 'toast-top-right',
    });
    return
    swal.fire({
        title: '成功加入購物車',
        type: 'success',
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonColor: 'var(--secondary_color)',
        confirmButtonText: t("carts.continueShopping2"),
        cancelButtonColor: 'var(--primary_color)',
        cancelButtonText: '直接結帳',
    }).then((result) => {
        // console.log('result', result);
        if (result.value) {
            // console.log('繼續購物');
        } else if (result.dismiss == "cancel") {
            // console.log('直接結帳');
            window.location.href = "/checkout";
        }
    })
}

const handleBuyNow = () => {
    alert("請選擇商品規格")
    buyNow.value = false
    setTimeout(function () {
        buyNow.value = true
    }, 200)

    return false
}

const levelState = reactive({
    item: null,
    visible: false,
})
const showCoinLevel = (item) => {
    // 佣金詳情
    levelState.item = item
    levelState.visible = true
}

const autoAddToCartGroup = () => {
    const temp = JSON.parse(localStorage.getItem('ADD_TO_CART_GROUP'))
    const addToCartGroupParams = temp ? temp.payload : null
    const redirect = temp ? temp.redirect : null
    // 登入後，自動加入購物車
    if (props.is_login && addToCartGroupParams && addToCartGroupParams.event_id == props.promotion.id) {
        addToCartByPayload(addToCartGroupParams, redirect)
    }
}

onMounted(async () => {
    autoAddToCartGroup()
})
</script>
<style>
.swal2-container {
    z-index: 3000;
}

.alerts-border {
    border: 3px #f34770 solid;
    animation: blink 1s;
    animation-iteration-count: 3;
}

@keyframes blink {
    50% {
        border-color: #fff;
    }
}
</style>
